import { getDesignerBuildInfo } from '../../components/TopHeader/Diagnostics/utils'

export function getDesignerVersion(): string {
  const valueDefault = '?'
  const { commit, version } = getDesignerBuildInfo()

  if (!version || version === 'refs/heads/master') {
    return `master-${commit?.substring(0, 8) || valueDefault}`
  }

  if (version.startsWith('refs/pull/')) {
    return `${version.replace(/refs\/pull\/(\d+).*/, '#$1')}-${
      commit?.substring(0, 8) || valueDefault
    }`
  }

  return `${version.replace('v', '').replace('refs/tags/', '') || valueDefault}`
}
